export function isAssignedToOperationalIdentity(
  assignedPersonnelIds: readonly string[] | null | undefined,
  personnelId: string | null,
  canManage: boolean,
): boolean {
  if (canManage || !assignedPersonnelIds || assignedPersonnelIds.length === 0) return true;
  return personnelId !== null && assignedPersonnelIds.includes(personnelId);
}
